// extracted by css-extract-rspack-plugin
export default {"container":"ChatScrollContainer-module__container__tNcwo"};